import Base from "@/controllers/base";
export default class Client extends Base {
  constructor(elem) {
    super(elem);
  }
}
